import Status from './status.vue'

export default Status
